import AssessmentTool from './AssessmentTool';

export default AssessmentTool;
